'use strict';

import template from './navbar.html';
import controller from './navbar.controller.js';
import './navbar.css';

const NavbarComponent = {
    bindings: {

    },
    template,
    controller
};

export default NavbarComponent;


// WEBPACK FOOTER //
// ./src/app/common/layout/navbar/navbar.component.js